import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.simulators', {
        url: '/simulators',
        component: 'companyManageApplicationIntegrationDevelopersSimulators',
        resolve: {
            credentials,
        },
    });
}

/** @ngInject */
function credentials(credentials$) {
    return credentials$.get();
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/simulators/simulators.state.js